import {StreamComponentType} from '@Components/ai-chat-window/lib/stream-component-registry.types';
import {defineStreamComponentRegistration} from '@Components/ai-chat-window/lib/stream-component-registration';
import {parseEachOrNull} from '@Components/ai-chat-window/lib/stream-component-prop-guards';
import {isPlainObject} from '@Utils/object.util';
import {isSafeWebUrlValue} from '@Utils/url.util';
import type {
  EntityThumbnailTileEntityType,
  EntityThumbnailTileItem,
  StreamedEntityThumbnailTileProps,
} from './components/streamed-entity-thumbnail-tile/streamed-entity-thumbnail-tile.types';
import {ENTITY_THUMBNAIL_TILE_CONFIGS} from './components/streamed-entity-thumbnail-tile/streamed-entity-thumbnail-tile.types';
import {StreamedEntityThumbnailTile} from './components/streamed-entity-thumbnail-tile/streamed-entity-thumbnail-tile';

const isEntityThumbnailTileEntityType = (value: unknown): value is EntityThumbnailTileEntityType => {
  const tiledEntityTypes: readonly unknown[] = Object.keys(ENTITY_THUMBNAIL_TILE_CONFIGS);

  return tiledEntityTypes.includes(value);
};

const isNonEmptyString = (value: unknown): value is string => {
  return typeof value === 'string' && value.trim() !== '';
};

const parseItem = (value: Record<string, unknown>): EntityThumbnailTileItem | null => {
  if (typeof value.entityRef !== 'string' || typeof value.title !== 'string' || !isSafeWebUrlValue(value.thumbnailUrl) || !isPlainObject(value.entity)) {
    return null;
  }

  return {entityRef: value.entityRef, title: value.title, thumbnailUrl: value.thumbnailUrl, entity: value.entity};
};

const parseEntityThumbnailTileProps = (props: Record<string, unknown>): StreamedEntityThumbnailTileProps | null => {
  if (!isEntityThumbnailTileEntityType(props.entityType) || !isNonEmptyString(props.heading) || !Array.isArray(props.items) || props.items.length === 0 || !isSafeWebUrlValue(props.viewMoreUrl)) {
    return null;
  }

  const items = parseEachOrNull(props.items, parseItem);
  if (!items) {
    return null;
  }

  return {entityType: props.entityType, heading: props.heading, items, viewMoreUrl: props.viewMoreUrl};
};

export const entityThumbnailTileRegistration = defineStreamComponentRegistration(StreamComponentType.ENTITY_THUMBNAIL_TILE, StreamedEntityThumbnailTile, parseEntityThumbnailTileProps);
